import { useEffect, useState, useCallback } from 'react';
import { useHistory } from 'react-router-dom';
import { useForm } from '../forms/useForm';
import { usePagination } from '../pagination/usePagination';
import { sendRequest } from '../requests/useRequest';
import { useSweetAlert } from '../sweetAlerts/useSweetAlert';
import { validarSesion } from '../tokens/useToken';

export const  useMorphology = () => {
    const history = useHistory();

    const [morphologys, setMorphologys] = useState([]);
    const [morphologyId, setMorphologyId] = useState(0);

    const [method, setMethod] = useState("");
    const [modal, setModal] = useState(false);
    const [modalTitle, setModalTitle] = useState("");

    const [loading, setLoading] = useState(false);
    const [createSweet] = useSweetAlert();
    const [searchMorphology, setSearchMorphology] = useState("");
    const [loadingExport, setLoadingExport] = useState(false);
    


    useEffect(() => {
        getMorphologys();
    }, []);


    const [formValues, handleInputChange, reset, handleUpdateValues] = useForm({
        morphology: "",
    });

    const { morphology } = formValues;


    const [validaciones, setValidaciones] = useState({
        morphology_valid: false,
    });

    const [modalAlert, setModalAlert] = useState(false);
    const [showDeleteAlert, setShowDeleteAlert] = useState(false);

    const openDeleteAlert = () => {
        setShowDeleteAlert(true); 
        setModalAlert(true);  
    };

    const closeDeleteAlert = () => {
        setModalAlert(false);   
    };

    const getMorphologys = async () => {
        let requestOptions = {
            method: 'GET'
        };

        const respuesta = await sendRequest(requestOptions, "Morphology/List");

        if (respuesta.code === 200) {
            let listMorphologys = [];
            let startItems = 0;
            let endItems = numberItems;
            let aux = numberItems * currentPage;

            endItems = aux;

            startItems = endItems - numberItems;
            if (respuesta.data.length >= 1) {
                respuesta.data.forEach((data, index) => {

                    let posicion = index + 1;
                    let visibleTable = false;

                    if (posicion > startItems && posicion <= endItems) {
                        visibleTable = true;
                    }

                    listMorphologys.push({
                        id_mic_morphology: data.id_mic_morphology,
                        morphology: data.morphology,
                        visibleTable: visibleTable
                    });
                });
                setMorphologys(listMorphologys);
                setMorphologysData(listMorphologys);
            }
            else {
                setMorphologys([]);
            }
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, getMorphologys);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Morfologias", "Ocurrio un problema en el servidor");
        }
        else {
            createSweet("error", "warning", "Morfologias", respuesta.data.msg);
        }
    }

    const openDialog = (title, mode) => {
        setModalTitle(title);
        setMethod(mode);
        setModal(true);
    };

    const closeDialog = () => {
        setModal(false);
    };
    

    const handleCreate = () => {
        handleUpdateValues({
            morphology: "",
            gram: "",
            id_mic_morphology: ""
        });

        setValidaciones({
            morphology_valid: false,
            gram_valid: false,
            id_mic_morphology_valid: false,
        });

        setMorphologyId(0);
        setMethod("create");
        setModalTitle("Crear morfologia");
        openDialog("Crear Morfología", "create");
    }

    const saveCreate = async (e) => {
        e.preventDefault();

        setLoading(true);

        if (validarForm()) {
            setLoading(false);
            return;
        }

        let mValues = JSON.stringify(formValues);

        let requestOptions = {
            method: 'POST',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Morphology");

        if (respuesta.code === 200) {
            getMorphologys();
            reset();
            createSweet("create", "success", "Exito!", "Morfologia creada con exito");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveCreate);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Morfologias", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Morfologias", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveCreate);
        // }
    }

    const handleUpdate = (id_morphology) => {
        let morphology = morphologys.find(s => s.id_mic_morphology === parseInt(id_morphology));

        handleUpdateValues({
            morphology: morphology.morphology,
            gram: morphology.gram,
            id_mic_morphology: morphology.id_mic_morphology,
        });

        setValidaciones({
            morphology_valid: false,
            gram_valid: false,
            id_mic_morphology_valid: false,
        });

        setMorphologyId(id_morphology);
        setMethod("update");
        setModalTitle("Actualización de morfologia");
        openDialog("Editar Morfología", "update");
    }

    const saveUpdate = async (e) => {
        e.preventDefault();

        let body = {
            id_mic_morphology: morphologyId,
            ...{ ...formValues }
        };

        let mValues = JSON.stringify(body);

        let requestOptions = {
            method: 'PUT',
            body: mValues
        };

        const respuesta = await sendRequest(requestOptions, "Morphology/Update");

        if (respuesta.code === 200) {
            getMorphologys();
            createSweet("create", "info", "Exito!", "Morfologia actualizada");
            setLoading(false);
            closeDialog();
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveUpdate);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Morfologias", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Morfologias", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveUpdate);
        // }
    }

    const handleDelete = (id_morphology) => {
        let morphology = morphologys.find(s => s.id_mic_morphology === id_morphology);

        handleUpdateValues({
            morphology: morphology.morphology,
            gram: morphology.gram,
            id_mic_morphology: morphology.id_mic_morphology,
        });

        setMorphologyId(id_morphology);
        setMethod("delete");
        setModalTitle("Eliminar morfologia");
        setShowDeleteAlert(true);
        setModalAlert(true);    
    }


    const saveDelete = async (e) => {
        e.preventDefault();

        let requestOptions = {
            method: 'DELETE'
        };

        const respuesta = await sendRequest(requestOptions, `Morphology/${morphologyId}`);
        if (respuesta.code === 200) {
            getMorphologys();
            setLoading(false);
            createSweet("create", "info", "Exito!", "Morfologia eliminada");
            setModalAlert(false);
            setShowDeleteAlert(false);
        }
        else if (respuesta.code === 401) {
            validarSesion(history, respuesta.code, saveDelete);
            setLoading(false);
        }
        else if (respuesta.code === 500) {
            createSweet("error", "error", "Morfologias", "Ocurrio un problema en el servidor");
            setLoading(false);
        }
        else {
            createSweet("error", "warning", "Morfologias", respuesta.data.msg);
            setLoading(false)
        }
        // else {
        //     setLoading(false);
        //     validarSesion(history, respuesta.code, saveDelete);
        // }

    }

    const validarForm = () => {
        let statusValidation = false;
        let newValidations = {};
        // morphology, gram, id_mic_morphology
        if (formValues.morphology === undefined || formValues.morphology.length < 1) {
            newValidations = {
                ...newValidations,
                morphology_valid: true
            };
            statusValidation = true;
        }
        else {
            newValidations = {
                ...newValidations,
                morphology_valid: false
            }
        }

        setValidaciones(newValidations);

        return statusValidation;
    }

    const numberItems = 10;
    const { totalPageCount, currentPage, nextPage, previousPage, goToPage } = usePagination(morphologys.length, numberItems);

    useEffect(() => {
        let startItems = 0;
        let endItems = numberItems;

        let aux = numberItems * currentPage;

        endItems = aux;

        startItems = endItems - numberItems;
        let listMorphologys = [];
        morphologys.forEach((data, key) => {

            let posicion = key + 1;
            let visibleTable = false;

            if (posicion > startItems && posicion <= endItems) {
                visibleTable = true;
            }

            listMorphologys.push({
                ...data,
                visibleTable: visibleTable
            });
        });

        setMorphologys(listMorphologys);
        // setMorphologysData(listMorphologys);
    }, [totalPageCount, currentPage])






    const [morphologysData, setMorphologysData] = useState([]);
    const handleSearch = (e) => {
        setSearchMorphology(e)

        let busqueda = e.toUpperCase();
        let newMorphology = [];

        morphologysData.forEach(element => {

            let cadena = element.morphology.toUpperCase();
            if (cadena.indexOf(busqueda.toUpperCase()) > -1) {
                element.visibleTable = true;
                newMorphology.push(element);
            }
        });
        setMorphologys(newMorphology);
    }

    const handleClearMorphology = () => {
        setSearchMorphology("");                         
        localStorage.removeItem("globalFilter");    
        setMorphologys(morphologysData);                    
    };


    const handleExportExcelMorphology = async () => {
        setLoadingExport(true);

        try {
            const XLSX = await import("xlsx");

            const _report = morphologys.map((item, index) => ({
                "#": index + 1, 
                Morfología: item.morphology ?? "---",
            }));

            const worksheet = XLSX.utils.json_to_sheet(_report);
            const workbook = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(workbook, worksheet, "Bacterias");

            const excelBuffer = XLSX.write(workbook, { bookType: "xlsx", type: "array" });

            const dataBlob = new Blob([excelBuffer], {
                type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
            });

            const url = window.URL.createObjectURL(dataBlob);
            const link = document.createElement("a");
            link.href = url;
            link.download = "catalogo_morfologías.xlsx";
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error al exportar Excel", error);
        }

        setLoadingExport(false);
    };

    return {
        morphologys, method, validaciones,
        morphology,
        handleInputChange, loading,
        closeDialog, modal, modalTitle,
        handleCreate, saveCreate,
        handleUpdate, saveUpdate,
        handleDelete, saveDelete,
        nextPage, previousPage, goToPage, totalPageCount, currentPage, handleSearch,
        modalAlert, showDeleteAlert, openDeleteAlert, closeDeleteAlert, 
        handleClearMorphology, searchMorphology, 
        loadingExport, handleExportExcelMorphology
    }
}
